import { Grid, makeStyles, Typography } from '@material-ui/core';
import { ITheme } from '../constants/theme';
import { useTranslation } from 'react-i18next';

interface IProps {
  total: number;
  subTotal: number;
  vat: number;
  vatRatio: number;
  discount: number;
  deliveryFee: number;
};

export const OrderedItemsPriceSection = ({ vat, vatRatio, total, subTotal, discount, deliveryFee }: IProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Grid container item direction="row" justifyContent="flex-end">
      <Grid className={classes.row} item container xs={12} justifyContent="flex-end">
        <Grid item container xs={6} justifyContent="space-between">
          <Typography
            variant="caption"
            component="span"
            color="textPrimary"
            align="right"
            className={classes.fw400}
          >
            Subtotal
          </Typography>
          <Typography
            variant="caption"
            component="span"
            color="textPrimary"
            align="right"
            className={classes.fw400}
          >
{t('currencySymbol')}{subTotal / 100}
          </Typography>
        </Grid>
      </Grid>
      {discount > 0 &&
        <Grid className={classes.row} item container xs={12} justifyContent="flex-end">
          <Grid item container xs={6} justifyContent="space-between">
            <Typography
              variant="caption"
              component="span"
              color="textPrimary"
              align="right"
              className={classes.fw400}
            >
              Discount
            </Typography>
            <Typography
              variant="caption"
              component="span"
              color="textPrimary"
              align="right"
              className={classes.fw400}
            >
              {/* can be discountedTotal */}
- {t('currencySymbol')}{discount / 100}
            </Typography>
          </Grid>
        </Grid>}
      <Grid className={classes.row} item container xs={12} justifyContent="flex-end">
        <Grid item container xs={6} justifyContent="space-between">
          <Typography
            variant="caption"
            component="span"
            color="textPrimary"
            align="right"
            className={classes.fw400}
          >
            Delivery fee
          </Typography>
          <Typography
            variant="caption"
            component="span"
            color="textPrimary"
            align="right"
            className={classes.fw400}
          >
            {/* can be discountedTotal */}
{t('currencySymbol')}{deliveryFee / 100}
          </Typography>
        </Grid>
      </Grid>
      <Grid className={classes.row} item container xs={12} justifyContent="flex-end">
        <Grid item container xs={6} justifyContent="space-between">
          <Typography
            variant="caption"
            component="span"
            color="textPrimary"
            align="right"
            className={classes.fw400}
          >
            VAT
          </Typography>
          <Grid item container justifyContent="space-between" xs={4}>
            <Typography
              variant="caption"
              component="span"
              color="textPrimary"
              align="right"
              className={classes.fw400}
            >
              {vatRatio * 100}%
            </Typography>
            <Typography
              variant="caption"
              component="span"
              color="textPrimary"
              align="right"
              className={classes.fw400}
            >
              {vat / 100}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid className={classes.row} item container xs={12} justifyContent="flex-end">
        <Grid item container xs={6} justifyContent="space-between">
          <Typography
            variant="caption"
            component="span"
            color="textPrimary"
            align="right"
          >
            Total
          </Typography>
          <Typography
            variant="caption"
            component="span"
            color="textPrimary"
            align="right"
          >
            {/* can be discountedTotal */}
{t('currencySymbol')}{total / 100}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  fw400: {
    fontWeight: 400,
  },
  row: {
    paddingTop: 8,
  },
}));